import React, { Component } from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import scriptLoader from 'react-async-script-loader';
import translate from 'app/translations';
import { StandaloneSearchBox } from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import autobind from 'react-autobind';

export class AddressSearch extends Component {
  constructor(props) {
    super(props);
    this.t = translate;
    this.map = null;
    this.searchBoxRef = undefined;
    this.searchInputRef = undefined;
    this.state = {
      hasMapsLoaded: false,
    };
    autobind(this);
  }

  componentWillReceiveProps(props) {
    this.loadmap(props);
  }

  onPlacesChanged() {
    const place = this.searchBoxRef.getPlaces().shift();
    if (place && place.address_components) {
      const address = this.parseAddress(place);
      if (address) {
        this.props.onAddressSelected(this.parseAddress(place));
        this.searchInputRef.input.value = '';
      }
    }
  }

  parseAddress(place) {
    let num = '';
    let street = '';
    let city = '';
    let neighborhood = '';
    let state = '';
    let county = '';
    let zip = '';
    let country = '';

    place.address_components.forEach((c) => {
      c.types.forEach((t) => {
        switch (t) {
          case 'street_number':
            num = c.long_name;
            break;
          case 'route':
            street = c.short_name;
            break;
          case 'neighborhood':
            neighborhood = c.long_name;
            break;
          case 'locality':
            city = c.long_name;
            break;
          case 'administrative_area_level_1':
            state = c.short_name;
            break;
          case 'administrative_area_level_2':
            county = c.short_name.replace(/\sCounty$/, '');
            break;
          case 'postal_code':
            zip = c.short_name;
            break;
          case 'country':
            country = c.short_name;
            break;
          default:
            break;
        }
      });
    });

    if (country === 'US') {
      return {
        city: city || neighborhood,
        state,
        street1: `${num} ${street}`.trim(),
        street2: null,
        zip,
        county,
        latitude: Number(place.geometry.location.lat().toFixed(5)),
        longitude: Number(place.geometry.location.lng().toFixed(5)),
      };
    }

    return null;
  }

  loadmap(props) {
    const { isScriptLoaded, isScriptLoadSucceed } = props;
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.setState({ hasMapsLoaded: true });
    }
  }

  initializeInputComponent(c) {
    if (c && c.input && c.input.input) {
      this.searchInputRef = c.input;
      this.searchInputRef.input.setAttribute('autoComplete', 'new-password');
    }
  }

  render() {
    return (
      <div>
        {this.state.hasMapsLoaded && (
          <StandaloneSearchBox
            ref={(c) => { this.searchBoxRef = c; }}
            onPlacesChanged={this.onPlacesChanged}
          >
            <Input.Search
              onPressEnter={(e) => { e.preventDefault(); }}
              ref={(c) => { setTimeout(() => { this.initializeInputComponent(c); }, 500); }}
              placeholder="Search for address"
            />
          </StandaloneSearchBox>
        )}
      </div>
    );
  }
}

AddressSearch.propTypes = {
  onAddressSelected: PropTypes.func.isRequired,
};

export default scriptLoader([
  'https://maps-api-ssl.google.com/maps/api/js?v=3&client=gme-redihiveinc&channel=appraiser-registration&libraries=places',
])(AddressSearch);
